import { useLDFlags } from './LD/useLDFlags';
import { useLeadAgeWithInThreshold } from './useLeadAgeThreshold';

/**
 * Returns boolean whether user should get free shipping based on FF
 * values
 * @param {boolean} checkRealtime
 * @returns
 */
export function useFreeShipping(checkRealtime) {
  const {
    'free-shipping': freeShipping,
    'vip-free-express': freeVipExpressShipping,
  } = useLDFlags();

  const isWithinLeadThreshold = useLeadAgeWithInThreshold(
    freeShipping?.threshold,
    checkRealtime
  );

  return (
    (freeShipping?.enabled && isWithinLeadThreshold) || freeVipExpressShipping
  );
}
